import { Card } from '../../SharedComponents/Card'
import { DataTable } from './DataTable'
import { StatusTag } from './StatusTag'
import { formatCurrency, formatDate } from '../../../lib/utils/format'
import type {
  Column,
  FileRow,
  FilesTableCardProps,
  StatusTagVariant,
} from '../types'
import styles from '../index.module.css'

const fileStatusVariant = (status: string): StatusTagVariant => {
  switch (status) {
    case 'Paid':
      return 'green'
    case 'Pending':
    case '3 Day Hold':
      return 'gold'
    case 'Bad Draft':
      return 'orange'
    case 'Cancelled':
      return 'red'
    case 'Limbo':
      return 'blue'
    case 'Clawback':
      return 'purple'
    default:
      return 'default'
  }
}

const columns: Column<FileRow>[] = [
  { title: 'DS #', key: 'dsid', accessor: 'dsid', sortable: true },
  { title: 'Client', key: 'client', accessor: 'client', sortable: true },
  { title: 'State', key: 'state', accessor: 'state', sortable: true },
  {
    title: 'True FPD',
    key: 'true_fpd',
    render: (r) => formatDate(r.true_fpd),
    sortable: true,
  },
  {
    title: 'FP Clear',
    key: 'fp_clear',
    render: (r) => formatDate(r.fp_clear),
    sortable: true,
  },
  {
    title: 'Cancel Date',
    key: 'cancel_date',
    render: (r) => formatDate(r.cancel_date),
    sortable: true,
  },
  {
    title: 'True Debt',
    key: 'true_debt',
    render: (r) => formatCurrency(r.true_debt, 0),
    sortable: true,
  },
  {
    title: 'Last Draft Status',
    key: 'last_draft_status',
    accessor: 'last_draft_status',
    sortable: true,
  },
  {
    title: 'Last Draft Date',
    key: 'last_draft_date',
    render: (r) => formatDate(r.last_draft_date),
    sortable: true,
  },
  {
    title: 'File Status',
    key: 'file_status',
    render: (r) =>
      r.file_status ? (
        <StatusTag variant={fileStatusVariant(r.file_status)}>
          {r.file_status}
        </StatusTag>
      ) : null,
    sortable: true,
  },
  {
    title: 'Per Deal $',
    key: 'per_deal',
    render: (r) => formatCurrency(r.per_deal),
    sortable: true,
  },
]

export default function FilesTableCard({
  rows,
  loading,
  onSortChange,
}: FilesTableCardProps) {
  return (
    <Card>
      <div className={styles.cardHeader}>MY FILES</div>
      <DataTable
        columns={columns}
        data={rows}
        rowKey="dsid"
        loading={loading}
        onSortChange={onSortChange}
        // To re-enable pagination, pass `pageSize={10}` (or any positive number).
      />
    </Card>
  )
}
